import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import type { NavGroup } from '../../config/navigation';

interface Props {
  group: NavGroup;
  onNavigate: () => void;
}

export function MobileAccordion({ group, onNavigate }: Props) {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const hasActiveChild = group.items.some((item) => {
    const path = item.path.startsWith('/') ? item.path : `/${item.path}`;
    return location.pathname === path;
  });

  return (
    <div>
      <button
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        className={`w-full flex items-center justify-between text-base font-semibold transition-colors ${
          hasActiveChild ? 'text-primary' : 'text-slate-600 hover:text-primary'
        }`}
      >
        {group.label}
        <svg
          className={`w-4 h-4 transition-transform duration-300 ${expanded ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          expanded ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="pl-4 pt-2 pb-1 space-y-2">
          {group.items.map((item) => {
            const path = item.path.startsWith('/') ? item.path : `/${item.path}`;
            const active = location.pathname === path;
            return (
              <Link
                key={item.path}
                to={path}
                onClick={onNavigate}
                className={`block text-sm font-medium transition-colors ${
                  active ? 'text-primary' : 'text-slate-500 hover:text-primary'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
